import type { LoginResponse, PublicConfig, UserInfo } from '@/types/domain'
import { buildUrl, http } from '@/platform/http'

export interface LoginData {
  username: string
  password: string
  captcha: string
  captchaId: string
  areaCode?: string
  mobile?: string
  email?: string
  emailCaptcha?: string
}

export interface RegisterData {
  username: string
  password: string
  confirmPassword: string
  captcha: string
  captchaId: string
  areaCode: string
  mobile?: string
  mobileCaptcha?: string
  email?: string
  emailCaptcha?: string
}

export interface RetrievePasswordData {
  password: string
  phone?: string
  email?: string
  code: string
  captcha: string
  captchaId: string
}

export interface SmsCodeData {
  phone: string
  captcha: string
  captchaId: string
}

export interface EmailCodeData {
  email: string
  captcha: string
  captchaId: string
}

export const authApi = {
  getCaptcha: async (uuid: string) => {
    const query = new URLSearchParams({ uuid })
    const response = await fetch(buildUrl(`/user/captcha?${query.toString()}`), {
      headers: { Accept: 'image/*' },
    })
    if (!response.ok) {
      throw new Error(`验证码加载失败：HTTP ${response.status}`)
    }
    return URL.createObjectURL(await response.blob())
  },
  login: (data: LoginData) => http.post<LoginResponse>('/user/login', data, { ignoreAuth: true }),
  register: (data: RegisterData) => http.post<LoginResponse>('/user/register', data, { ignoreAuth: true }),
  sendSmsCode: (data: SmsCodeData) => http.post<void>('/user/smsVerification', data, { ignoreAuth: true, toastError: false }),
  sendEmailCode: (data: EmailCodeData) => http.post<void>('/user/emailVerification', data, { ignoreAuth: true, toastError: false }),
  retrievePassword: (data: RetrievePasswordData) => http.put<void>('/user/retrieve-password', data, { ignoreAuth: true }),
  getUserInfo: () => http.get<UserInfo>('/user/info', { toastError: false }),
  updateUserInfo: (data: Partial<UserInfo>) => http.put<void>('/user/info', data),
  getPublicConfig: () => http.get<PublicConfig>('/user/pub-config', { ignoreAuth: true, toastError: false }),
}
